import { api } from "../../../api";
// import axios from "axios";
// import { useNavigate } from "react-router";
// import { toast } from "react-toastify";

const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
const hrRoot = process.env.REACT_APP_BACKEND_HR_URL;
const route = api(root);
const hrRoute = api(hrRoot);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

const PaymentSetupServices = {
  async getPaymentRequest({
    search,
    startDate,
    endDate,
    pageSize,
    pageNumber,
  }) {
    try {
      let { data } = await route.get(
        `/PaymentRequestSetup/all?PageSize=${pageSize}&PageNumber=${pageNumber}&Search=${search}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async deletePaymentRequest(payload) {
    try {
      let { data } = await route.post(`PaymentRequestSetup/delete`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async approveNarration(payload) {
    try {
      let { data } = await route.post(`PaymentOfNaration/approve`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async declineNarration(payload) {
    try {
      let { data } = await route.post(`PaymentOfNaration/delete`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async getPaymentNarrations({
    search,
    pageSize,
    pageNumber,
  }) {
    try {
      let { data } = await route.get(
        `/PaymentOfNaration/all?PageSize=${pageSize}&PageNumber=${pageNumber}&Search=${search}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async getAllDepts() {
    try {
      let { data } = await hrRoute.get(
        "/Department/AllDepartment?PageSize=100&PageNumber=1",
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data.responseObject.pageItems;
    } catch (e) {
      console.log({ deptError: e.response.data || e });
      return e.response.data;
    }
  },
  async getAllContainer() {
    try {
      let { data } = await hrRoute.get(
        "Container/AllContainer?PageSize=100&PageNumber=1",
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data?.responseObject?.pageItems;
    } catch (e) {
      console.log({ deptError: e.response.data || e });
      return e.response.data;
    }
  },
  async getAllEmployees(Search = "") {
    try {
      let { data } = await hrRoute.get(
        `/Employee/GetAllEmployees?PageSize=100&PageNumber=1&Search=${Search}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data.result;
    } catch (e) {
      console.log({ errEmployees: e.response.data || e });
      return [];
    }
  },
  async getPaymentType({ pageSize, pageNumber }) {
    try {
      let { data } = await route.get(
        `PaymentType/all?PageSize=${pageSize || "10000"}&PageNumber=${pageNumber || "1"}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log({ e });
    }
  },
  async getFeeSetup({ pageSize, pageNumber }) {
    try {
      let { data } = await route.get(
        `FeeSetup/all?PageSize=${pageSize}&PageNumber=${pageNumber}&Status=0`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log({ e });
    }
  },


  async createExchangeRateSetup(payload) {
    try {
      let { data } = await route.post(`exchangerate/create`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },

  async updateExchangeRateSetup(payload) {
    try {
      let { data } = await route.post(`/exchangerate/update`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },


  async getExchangeRateSetup({ pageSize, pageNumber, ApprovalStatus }) {
    try {
      const params = new URLSearchParams({
        PageSize: pageSize,
        PageNumber: pageNumber,
        ApprovalStatus: ApprovalStatus || "", // Include Status parameter if it exists
      }).toString();

      const response = await route.get(`/exchangerate/getall?${params}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Ensure `token` is defined and valid
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching withholding tax setup:", error);
      // Optionally, handle the error further (e.g., show a user-friendly message)
      throw error; // Re-throw the error if needed
    }
  },

  async getWitholdingTaxSetup({ pageSize, pageNumber, Status, VendorTypeId }) {
    try {
      const params = new URLSearchParams({
        PageSize: pageSize,
        PageNumber: pageNumber,
        Status: Status || "", // Include Status parameter if it exists
        VendorTypeId: VendorTypeId || "",
      }).toString();

      const response = await route.get(`WitholdingTaxSetup/all?${params}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Ensure `token` is defined and valid
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching withholding tax setup:", error);
      // Optionally, handle the error further (e.g., show a user-friendly message)
      throw error; // Re-throw the error if needed
    }
  },

  async getWitholdingTaxSetupId(id) {
    try {
      const response = await route.get(`WitholdingTaxSetup/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Ensure `token` is defined and valid
        },
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching withholding tax setup:", error);
      // Optionally, handle the error further (e.g., show a user-friendly message)
      throw error; // Re-throw the error if needed
    }
  },

  async getPaymentRecognitionSetup({
    pageSize,
    pageNumber,
    Status,
    installementType,
  }) {
    try {
      // Initialize the base URL
      let url = `PaymentRecognitionSetup/all?`;

      // Build the query parameters dynamically
      const params = new URLSearchParams();
      if (pageSize) params.append("PageSize", pageSize);
      if (pageNumber) params.append("PageNumber", pageNumber);
      if (Status) params.append("Status", Status);
      if (installementType) params.append("InstallementType", installementType);

      // Append query parameters to the URL
      url += params.toString();

      // Perform the API request
      let { data } = await route.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },

  async getAccountLedgerSetup({ pageSize, pageNumber, ApprovalStatus }) {
    try {
      let { data } = await route.get(
        `AccountLedger/GetAllAccounts?PageSize=${pageSize}&PageNumber=${pageNumber}&ApprovalStatus=${ApprovalStatus}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      return data;
    } catch (e) {
      console.log({ e });
    }
  },

  async createPaymentRecognitionSetup(payload) {
    try {
      let { data } = await route.post(`/PaymentRecognitionSetup`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },

  async updatePaymentRecognitionSetup(payload) {
    try {
      let { data } = await route.post(
        `/PaymentRecognitionSetup/update`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log({ e });
    }
  },

  async updateWitholdingTaxSetup(payload) {
    try {
      let { data } = await route.post(`/WitholdingTaxSetup/update`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },

  async createPaymentWitholdingTaxSetup(payload) {
    try {
      let { data } = await route.post(`/WitholdingTaxSetup`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },

  async updatePaymentType(payload) {
    try {
      let { data } = await route.post(`/PaymentType/update`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },
  async approvePaymentType(payload) {
    try {
      let { data } = await route.post(`PaymentType/approve`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  // approvePaymentRecognitionSetup
  async approvePaymentRecognitionSetup(payload) {
    try {
      let { data } = await route.post(
        `PaymentRecognitionSetup/approve`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },

  async declinePaymentRecognitionSetup(payload) {
    try {
      let { data } = await route.post(
        `PaymentRecognitionSetup/decline`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },

  async declineWitholdingTaxSetup(payload) {
    try {
      let { data } = await route.post(`WitholdingTaxSetup/decline`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },

  async approveWitholdingTaxSetup(payload) {
    try {
      let { data } = await route.post(`WitholdingTaxSetup/approve`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },

  async deletePaymentRecognitionSetup(payload) {
    try {
      let { data } = await route.post(
        `PaymentRecognitionSetup/delete`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },

  async declinePaymentType(payload) {
    try {
      let { data } = await route.post(`PaymentType/delete`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log("error", e);
    }
  },
  async createPayment(payload) {
    try {
      let { data } = await route.post(`/PaymentRequestSetup`, payload, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });

      return data;
    } catch (e) {
      console.log({ e });
    }
  },
  async createNarration(payload) {
    try {
      let { data } = await route.post(
        `/PaymentOfNaration/add`,
        { ...payload },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log({ e });
      // toast.error("Unable to create narration, possible duplicate...");
    }
  },
  async editNarration(payload) {
    try {
      let { data } = await route.post(
        `/PaymentOfNaration/update`,
        { ...payload },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log({ e });
    }
  },
  async updatePayment(payload) {
    try {
      let { data } = await route.post(
        `/PaymentRequestSetup/update`,
        { ...payload },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data;
    } catch (e) {
      console.log({ e });
    }
  },
};

export default PaymentSetupServices;
